import { render } from "./PartnerSetBonus.vue?vue&type=template&id=9ce95064"
import script from "./PartnerSetBonus.vue?vue&type=script&lang=js"
export * from "./PartnerSetBonus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__